/** Desktop AI-guide mascot. Hidden below the md breakpoint so phones do not download it. */
export function shouldRenderHomepageMascot(isMdUp) {
  return Boolean(isMdUp);
}
